// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"384":"006a19e0","418":"a60110e5","628":"3fd85eb7"}[chunkId] + ".chunk.js";
};